<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <div class="w-1/2">
          <div class="flex gap-4 items-center">
            <vs-input
              class="inputx mb-1 w-1/2"
              v-model="model.code"
              type="number"
              name="AccountCode"
              :label="$t('AccountCode')"
              v-validate="'required'"
            />
          </div>
          <span
            class="text-danger text-sm"
            v-show="errors.has('AccountCode')"
            >{{ errors.first("AccountCode") }}</span
          >
        </div>

        <div>
          <vs-input
            class="inputx mb-1 mt-1"
            v-model="model.title"
            name="AccountGroupTitle"
            :label="$t('AccountGroupTitle')"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('AccountGroupTitle')"
            >{{ errors.first("AccountGroupTitle") }}</span
          >
        </div>

        <div>
          <vs-textarea
            rows="5"
            class="mt-4"
            name="Description"
            :label="$t('Description')"
            v-model="model.description"
          />
        </div>

        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled=" !model.code || !model.title"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    AccountCode: {
      required: "لطفا کد حساب را وارد نمایید.",
    },
    AccountGroupTitle: {
      required: "لطفا عنوان گروه حساب را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  data() {
    return {
      AccountTitle: "",
      popupTitle: "",
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createAccount: "groupAccount/create",
      updateAccount: "groupAccount/update",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.model.id != null) {
            this.updateAccount(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          } else {
            this.createAccount(this.model).then(() => {

              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          }
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;

        if (this.model.id) this.popupTitle = "EditAccount";
        else this.popupTitle = "CreateNewGroupAccount";
      }
      this.$validator.reset();
    },
  },
};
</script>
